import { FiShoppingBag, FiGlobe, FiLayers } from "react-icons/fi";
import { SECTIONS } from "@/config/constants";
import { useExploreStore } from "./exploreStore";

const OPTIONS = [
  {
    value: SECTIONS.PK_FASHION,
    label: "PK Fashion",
    desc: "Pakistani designer clothing",
    icon: FiShoppingBag,
  },
  {
    value: SECTIONS.NA_PRODUCTS,
    label: "NA Products",
    desc: "North American products",
    icon: FiGlobe,
  },
  {
    value: SECTIONS.BOTH,
    label: "Both",
    desc: "Explore everything",
    icon: FiLayers,
  },
];

/**
 * Shown on each new visit until the visitor picks a section to explore.
 * Blocks the app behind a full-screen overlay (one quick choice).
 */
export function SectionGate() {
  const section = useExploreStore((s) => s.section);
  const setSection = useExploreStore((s) => s.setSection);

  if (section) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 p-4">
      <div className="w-full max-w-lg">
        <h2 className="mb-2 text-center text-2xl font-bold text-foreground">
          What would you like to explore?
        </h2>
        <p className="mb-6 text-center text-muted-foreground">
          Pick a section to get started — you can switch anytime.
        </p>
        <div className="grid gap-4 sm:grid-cols-3">
          {OPTIONS.map((o) => (
            <button
              key={o.value}
              onClick={() => setSection(o.value)}
              className="flex flex-col items-center gap-2 rounded-lg border border-border bg-card p-6 text-center transition-colors hover:border-primary hover:bg-secondary"
            >
              <o.icon size={28} className="text-primary" />
              <span className="font-medium text-foreground">{o.label}</span>
              <span className="text-xs text-muted-foreground">{o.desc}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SectionGate;
